import { render, staticRenderFns } from "./CriteriaTable.vue?vue&type=template&id=2bb0beae"
import script from "./CriteriaTable.vue?vue&type=script&lang=js"
export * from "./CriteriaTable.vue?vue&type=script&lang=js"
import style0 from "./CriteriaTable.vue?vue&type=style&index=0&id=2bb0beae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports